// extracted by mini-css-extract-plugin
export default {"carousel_services":"Services_carousel_services__7Ehxk"};